import {useQueryParams} from 'presentation/pages';
import {useGetOdontoAvailableTimesQuery} from '../../../../queries/useGetOdontoAvailableTimesQuery';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {textHandle} from 'presentation/utils/textHandle';
import {isUnprocessableError} from 'presentation/utils/isUnprocessableError';
import {useMemo} from 'react';
import {AvailableTimeItem} from '../../../../queries/useGetOdontoAvailableTimesQuery/types';

export function useOdontoSelectedDateProfessionalList() {
	const {
		SEARCH_PARAMS: {query},
	} = useQueryParams();
	const bookingData = useBookingStore(state => state.bookingData);
	const selectedDate = bookingData.dateAt;
	const normalizedQuery = textHandle(query).sanitizeText();
	const queryToFilter = normalizedQuery === 'clear' ? '' : normalizedQuery;

	const {
		data: odontoAvailableTimes,
		isFetching: isFetchingOdontoAvailableTimes,
		error: errorOdontoAvailableTimes,
		refetch: odontoAvailableTimesRefetch,
	} = useGetOdontoAvailableTimesQuery({
		enabled: true,
	});

	const notFoundOdontoAvailableTimesError = isUnprocessableError(errorOdontoAvailableTimes);

	const odontoAvailableTimesFiltered = useMemo(() => {
		if (!queryToFilter) return odontoAvailableTimes;

		return odontoAvailableTimes?.filter(({professionalName}) =>
			textHandle(professionalName).sanitizeText().includes(queryToFilter),
		);
	}, [odontoAvailableTimes, queryToFilter]) as AvailableTimeItem[];

	const showNotFoundState =
		odontoAvailableTimesFiltered?.length === 0 || notFoundOdontoAvailableTimesError;

	const isError = errorOdontoAvailableTimes && !notFoundOdontoAvailableTimesError;
	const isLoading = isFetchingOdontoAvailableTimes;

	return {
		isLoading,
		isError,
		showNotFoundState,
		selectedDate,
		odontoAvailableTimesFiltered,
		query,
		odontoAvailableTimesRefetch,
	};
}
